module.exports = __webpack_public_path__ + "img/slide4.6f5193d5.png";